import type { NextPage } from 'next';
import useUser from '../auth/useUser';
import CompanySelector from 'ui/components/companySelector/company-selector';
import { TenantEnum } from 'contactabilidad-common';

const Main: NextPage = () => {
  const currentUser = useUser();

  return (
    <CompanySelector
      user={currentUser}
      options={{
        gascaribe: {
          path: `${TenantEnum.gdc}/contact-validation`,
          role: 'access_gdc',
        },
        gasguajira: {
          path: `${TenantEnum.gdg}/contact-validation`,
          role: 'access_gdg',
        },
        efigas: {
          path: `${TenantEnum.efg}/contact-validation`,
          role: 'access_efg',
        },
      }}
    />
  );
};

export default Main;
